import React, {Fragment} from 'react';
import {Text, View, StyleSheet } from '@react-pdf/renderer';
import moment from "moment";
import CancellationExperience from './CancellationExperience';
import CancellationAccommodation from './CancellationAccommodation';
import CancellationAccommodationEjunifer from './CancellationAccommodationEjunifer';
import { padding } from '@mui/system';

const borderColor = '#F5F5F5'
const styles = StyleSheet.create({
    row: {
        flexDirection: 'row',
        borderBottomColor: '#F5F5F5',
        borderBottomWidth: 1,
        alignItems: 'center',
        height: 24,
        fontStyle: 'bold',
        height: 40,
        fontStyle: 'bold',
        overflowY: 'scroll',
        justifyContent: 'center',
    },
    offer:{
      backgroundColor: 'green',
    },
  //   refrence: {
  //     width: '20%',
  //     textAlign: 'left',
  //     borderRightColor: borderColor,
  //     borderRightWidth: 1,
  //     paddingLeft: 8,
  //     paddingTop: 15,
  //     height: 40,
  // },
    description: {
        width: '30%',
        textAlign: 'left',
        borderRightColor: borderColor,
        borderRightWidth: 1,
        paddingLeft: 8,
        paddingTop: 7,
        height: 45,
    },
    details: {
      width: '30%',
      textAlign: 'left',
      borderRightColor: borderColor,
      borderRightWidth: 1,
      paddingLeft: 8,
      paddingTop: 7,
      height: 45,
  },
    service_date: {
        width: '15%',
        borderRightColor: borderColor,
        borderRightWidth: 1,
        textAlign: 'left',
        paddingLeft: 8,
        paddingTop: 7,
        height: 45,
    },
    rate: {
      width: '25%',
      borderRightColor: borderColor,
      borderRightWidth: 1,
      textAlign: 'right',
      paddingRight: 8,
      paddingTop: 7,
      height: 45,
  },
  cancellationpolicy:{
    borderBottomColor: '#F5F5F5',
    borderBottomWidth: 1,
  },
  redText: {
    borderColor: '#eb2026',
    color: '#eb2026',
    padding:4
  },
  spriteNew: {
    background: 'none',
    backgroundColor: '#eb2026',
    color:'#fff',
    borderRadius: 10,
    width: 'auto',
    height: 'auto',
    fontSize: 7,
    padding:5
},
linecutting:{
  textDecoration: 'line-through',
  fontSize: 9,
  fontWeight: 900,
},
fontweightMain:{
  fontWeight: 900,
  fontSize: 10,
  lineBreak:'normal',
  marginBottom:1
},
fontweightMainNormal:{
  fontWeight: 900,
  fontSize: 10,
},
offerSave:{
  marginTop:1
}
  });

  const getTotalNumber = (item) => {
    if (item.profileactivity != "Accommodations") {
      const GuesttravellerCount = JSON.parse(item.numberTraveler);
      return (
        <>
          {item.price_type == 1 ? (
            <>
              {GuesttravellerCount.reduce((a, v) => a + v.adultCounter * 1, 0) >
                0 && (
                <>
                  <Text>
                    {GuesttravellerCount.reduce(
                      (a, v) => a + v.adultCounter * 1,
                      0
                    )}
                  </Text>
                  &nbsp;Adults,&nbsp;
                </>
              )}

              {GuesttravellerCount.reduce((a, v) => a + v.childCounter * 1, 0) >
                0 && (
                <>
                  <Text>
                    {GuesttravellerCount.reduce(
                      (a, v) => a + v.childCounter * 1,
                      0
                    )}
                  </Text>
                  &nbsp;Children&nbsp;
                </>
              )}

              {GuesttravellerCount.reduce(
                (a, v) => a + v.infantCounter * 1,
                0
              ) > 0 && (
                <>
                  <Text>
                    {GuesttravellerCount.reduce(
                      (a, v) => a + v.infantCounter * 1,
                      0
                    )}
                  </Text>
                  &nbsp;Infant,&nbsp;
                </>
              )}

              {GuesttravellerCount.reduce((a, v) => a + v.youthCounter * 1, 0) >
                0 && (
                <>
                  <Text>
                    {GuesttravellerCount.reduce(
                      (a, v) => a + v.youthCounter * 1,
                      0
                    )}
                  </Text>
                  &nbsp;Youth,&nbsp;
                </>
              )}

              {GuesttravellerCount.reduce(
                (a, v) => a + v.seniorCounter * 1,
                0
              ) > 0 && (
                <>
                  <Text>
                    {GuesttravellerCount.reduce(
                      (a, v) => a + v.seniorCounter * 1,
                      0
                    )}
                  </Text>
                  &nbsp;Senior,&nbsp;
                </>
              )}
            </>
          ) : (
            <>
              {GuesttravellerCount.reduce((a, v) => a + v.groupCounter * 1, 0) >
                0 && (
                <>
                  <Text>
                    {GuesttravellerCount.reduce(
                      (a, v) => a + v.groupCounter * 1,
                      0
                    )}
                  </Text>
                  &nbsp;Travelers,&nbsp;
                </>
              )}
            </>
          )}
        </>
      );
    } else {
      if (item.typedata == "multiple") {
        const GuesttravellerCount = item.cartvalue;

        return (
          <>
            {GuesttravellerCount.reduce((a, v) => a + v.adultCounter * 1, 0) >
              0 && (
              <>
                <Text>
                  {GuesttravellerCount.reduce(
                    (a, v) => a + v.adultCounter * 1,
                    0
                  )}
                </Text>
                &nbsp;Adults,&nbsp;
              </>
            )}
            {GuesttravellerCount.reduce((a, v) => a + v.childCounter * 1, 0) >
              0 && (
              <>
                <Text>
                  {GuesttravellerCount.reduce(
                    (a, v) => a + v.childCounter * 1,
                    0
                  )}
                </Text>
                &nbsp;Childs,&nbsp;
              </>
            )}

            {GuesttravellerCount.reduce((a, v) => a + v.roomCounter * 1, 0) >
              0 && (
              <>
                <Text>
                  {GuesttravellerCount.reduce(
                    (a, v) => a + v.roomCounter * 1,
                    0
                  )}
                </Text>
                &nbsp;Room,&nbsp;
              </>
            )}
          </>
        );
      } else {
        const GuesttravellerCount = item.guestCombination;
        return (
          <>
            {GuesttravellerCount.reduce((a, v) => a + v.adultCounter * 1, 0) >
              0 && (
              <>
                <Text>
                  {GuesttravellerCount.reduce(
                    (a, v) => a + v.adultCounter * 1,
                    0
                  )}
                </Text>
                &nbsp;Adults,&nbsp;
              </>
            )}
            {GuesttravellerCount.reduce((a, v) => a + v.childCounter * 1, 0) >
              0 && (
              <>
                <Text>
                  {GuesttravellerCount.reduce(
                    (a, v) => a + v.childCounter * 1,
                    0
                  )}
                </Text>
                &nbsp;Childs,&nbsp;
              </>
            )}

            {GuesttravellerCount.reduce((a, v) => a + v.roomCounter * 1, 0) >
              0 && (
              <>
                <Text>
                  {GuesttravellerCount.reduce(
                    (a, v) => a + v.roomCounter * 1,
                    0
                  )}
                </Text>
                &nbsp;Room,&nbsp;
              </>
            )}
          </>
        );
      }
    }
  };

  const getAmountPrice = (item) => {
 
         if(item?.totalAmount==item?.totalamountincluded){
           return (
             <Text style={styles.fontweightMainNormal}><b>€ {parseFloat(item?.totalamountincluded).toFixed(2)}</b></Text>
           );
          }else if(item?.totalAmount==0){
            return (
              <Text style={styles.fontweightMainNormal}><b>€ {parseFloat(item?.totalamountincluded).toFixed(2)}</b></Text>
            );  
         }else{
           return (
             <>
               
               <Text style={styles.linecutting}>
               
               € {parseFloat(item?.totalAmount).toFixed(2)}{'\n'}
               </Text>
              
               <Text style={styles.offerSave}>
                 <Text style={styles.redText}>
                   <Text>Save &nbsp;</Text>
                   <Text>
                     € 
                     {parseFloat(item?.percentageAm).toFixed(2)}{" "}
                   </Text>
                 </Text>
                 <Text style={styles.spriteNew}>
                   &nbsp; {item?.percentage}{" "}%
                 </Text>
                
               </Text>
               <Text style={styles.fontweightMain}> 
              <b> {'\n'} € 
              {parseFloat(item?.totalamountincluded).toFixed(2)}</b>
               </Text>
             </>
           );
         }
      
     };

     const getAccomodationDetails = (item) => {
      // console.log(item.junifer);
      return(<>
     {item?.junifer != null ? (
      <>
        {item?.junifer?.HotelRooms?.HotelRoom
          .length > 0 ? (
        
          <>
            {" "}
            {item?.junifer?.HotelRooms?.HotelRoom.map(
              (roomname, index) => (
                <>
                  <Text>
                      {roomname?.attributes?.Units}{" "}
                      X {roomname?.Name} (
                      {item?.junifer?.Board})
                  </Text>
                </>
              )
            )}
          </>
        ) : (
          <>
            <Text>
              
                {
                  item?.junifer?.HotelRooms
                    .HotelRoom.attributes.Units
                }{" "}
                X{" "}
                {
                  item.junifer.HotelRooms
                    .HotelRoom.Name
                }{" "}
                ({item.junifer.Board})
              
            </Text>
          </>
        )}
      </>
    ) : (
      <>
        {item?.typedata == "multiple" ? (
          <>
            {item?.cartvalue.map(
              (cartitem, indexcart) => (
                <>
                  <Text>
                      {cartitem?.roomCounter} X{" "}
                      {cartitem?.name}
                  </Text>
                </>
              )
            )}
          </>
        ) : (
          <>
            <Text>
                1 X {item?.roomname}
            </Text>
          </>
        )}
      </>
    )}
    </>
      );
        };
const InvoiceTableRow = ({items}) => {

  var items1 = (JSON.stringify(items));
    var items2 = JSON.parse(items1);
    var items3 = JSON.parse(items2);
  const rows =  items3.child!=null && items3.child.map( item => 
        <View>
        <View style={styles.row} key={item.booking_refrence_id}>
            {/* <Text style={styles.refrence}>{item.booking_source == 1? item.booking_refrence_id+'-'+item.ReservationLocation:item.booking_source ==2? item.booking_refrence_id+'-'+item.hl_booking_id:item.booking_refrence_id}</Text> */}
              <Text style={styles.description}> {item.profileactivity == "Accommodations" ?item.propertyName:item.tourName}</Text>
              <Text style={styles.details}> {item.profileactivity == "Accommodations" ?item&&(getAccomodationDetails(item)):item.tourOption} ({getTotalNumber(item)}){item.profileactivity == "Transfers" &&item.pickuptransfer &&(` Pickup ${item.pickuptransfer} to ${item.droptransfer}`)}</Text>
              <Text style={styles.service_date}>{item.profileactivity == "Accommodations" ? moment(item.startDate).format("D MMM Y") +' - '+moment(item.endDate).format("D MMM Y"):moment(item.dateselected).format("D MMM Y")}</Text>
            <Text style={styles.rate}>{getAmountPrice(item)}</Text>
          </View >
          {item?.profileactivity != "Accommodations"? (<CancellationExperience invoice={item} />):(item?.accommodationtype == 'ejunifer'?<CancellationAccommodationEjunifer invoice={item} />:<CancellationAccommodation invoice={item} />)} 
            </View>
  )
  return (<Fragment>{rows}</Fragment> )
};
export default InvoiceTableRow